// import React, { useEffect, useState, useMemo } from 'react';
// import { useSelector } from 'react-redux';
// import { startOfDay } from 'date-fns';
// import { toZonedTime } from 'date-fns-tz';
// import { Box } from '@mui/material';


// const NowLine = ({ 
//     baseDate,
//     datesCount,
//     cellWidth,
//     height,
// }) => {
//     const timeMode = useSelector((state) => state.timemode);
//     const zonedDate = useMemo(() => timeMode === 'UTC' 
//         ? toZonedTime(new Date(), 'UTC') 
//         : new Date()
//     , [timeMode]);
//     const [now, setNow] = useState(zonedDate);

//     useEffect(() => {
//         const timer = setInterval(() => {
//             setNow(zonedDate);
//         }, 6000);

//         return () => clearInterval(timer);
//     }, [zonedDate]);

//     const left = useMemo(() => {
//         if (!baseDate) return 0;

//         const base = startOfDay(new Date(baseDate));
//         const diffMs = now.getTime() - base.getTime();
//         const diffHours = diffMs / (1000 * 60 * 60);

//         return diffHours * cellWidth;
//     }, [now, baseDate, cellWidth]);

//     const maxWidth = useMemo(() => datesCount * 24 * cellWidth, [datesCount, cellWidth]);
//     if (left == null || left < 0 || left > maxWidth) {
//         return null;
//     }

//     return (
//         <Box
//             sx={{
//                 position: 'absolute',
//                 top: 0,
//                 left,
//                 height,
//                 width: '2px',
//                 bgcolor: 'error.main',
//                 zIndex: 9,
//                 pointerEvents: 'none', // Non block drag/click
//             }}
//         >
//             {/* <Box // Show time on the top of line
//                 sx={{
//                 position: 'absolute',
//                 top: 0,
//                 left: -16,
//                 bgcolor: 'error.main',
//                 color: '#fff',
//                 fontSize: '0.65rem',
//                 px: 0.5,
//                 borderRadius: 1,
//                 whiteSpace: 'nowrap',
//                 }}
//             >
//                 {format(now, 'HH:mm')}
//             </Box> */}
//         </Box>
//     );
// };



import React, { useEffect, useMemo, useRef, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { startOfDay } from 'date-fns';
import { toZonedTime } from 'date-fns-tz';


const NowLine = ({ 
    baseDate = new Date(),
    datesCount = 1,
    cellWidth = 20,
    height = 50,
}) => {
    const timeMode = useSelector((state) => state.timemode);
    const lineRef = useRef(null);

    // Calculate 'left' position upon Now and baseDate
    const calcLeft = useCallback(() => {
        if (!baseDate) return -999;
        
        const now = timeMode === 'UTC' 
            ? toZonedTime(new Date(), 'UTC') 
            : new Date();
            
        const base = startOfDay(new Date(baseDate));
        const diffHours = (now.getTime() - base.getTime()) / 3600000;
        const left = diffHours * cellWidth;

        return left;
    }, [baseDate, cellWidth, timeMode]);

    const initialLeft = useMemo(() => calcLeft(), [calcLeft]);
    const maxWidth = useMemo(() => datesCount * 24 * cellWidth, [datesCount, cellWidth]);

    useEffect(() => {
        const timer = setInterval(() => {
            if (lineRef.current) {
                const newLeft = calcLeft();
                
                // Kiểm tra ẩn/hiện nếu ra ngoài phạm vi biểu đồ
                if (newLeft < 0 || newLeft > maxWidth) {
                    lineRef.current.style.display = 'none';
                } else {
                    lineRef.current.style.display = 'block';
                    lineRef.current.style.left = `${newLeft}px`;
                }
            }
        }, 60000);

        return () => clearInterval(timer);
    }, [calcLeft, maxWidth]);

    // Nếu vị trí ban đầu nằm ngoài phạm vi
    if (initialLeft < 0 || initialLeft > maxWidth) return null;

    return (
        <div
            ref={lineRef}
            style={{
                position: 'absolute',
                top: 0,
                left: `${initialLeft}px`,
                height: height || '100%',
                width: '2px',
                backgroundColor: '#d32f2f',
                zIndex: 9,
                pointerEvents: 'none',
                willChange: 'left',
                transition: 'left 0.3s linear'
            }}
        />
    );
};

export default React.memo(NowLine);